import { Header, Footer } from '@/shared/components/layout';
import { useDocumentTitle } from '@/shared/hooks';
import {
  // Hero22,
  ROIPricingCalculator,
  SimpleFlexiblePricing,
  PricingQA,
  TryItFree
} from './Components';

const PricingPage = () => {
  useDocumentTitle('Buy Leads & Pricing - BrokerMax');
  return (
    <div className="min-h-screen">
      <Header variant="light-hero" />
      <main>
        {/* <Hero22 /> */}
        <ROIPricingCalculator />
        <SimpleFlexiblePricing />
        <PricingQA />
        <TryItFree />
      </main>
      <Footer />
    </div>
  );
};

export default PricingPage;
